// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_LO0Wp"};